export default __webpack_public_path__ + "static/media/kenny.4508c9be.JPG";